import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { theme, toRem } from '@marriott/mi-ui-library-shop';

export const StyledUsePointsDiv = styled.div`
  ${rtl`
  label {
    color: ${theme.color['base-10']};
    z-index:1;
  }
  span {
    display: inline-block;
    &:before {
      @media ${theme.mediaQuery.tablet} {
        top: ${toRem(2)};
      }
    }
  }
`}
`;
